import { firstName, WizardDone } from "@/components/wizard/done-screen";

import type { Draft } from "../../-utils/fields";

export function DoneScreen({ draft }: { draft: Draft }) {
	return (
		<WizardDone
			title={`Prontinho, ${firstName(draft.name)}!`}
			description="Recebemos o seu cadastro. A equipe já vai dar uma olhada e a gente se fala pelo WhatsApp."
		/>
	);
}
